"use strict";

var _regeneratorRuntime = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("firebase/auth");

var firestore_1 = require("firebase/firestore");

var nanoid_1 = require("nanoid");

var slug_1 = __importDefault(require("slug"));

var Model_1 = __importDefault(require("../Model"));

var Schema = /*#__PURE__*/function (_Model_1$default) {
  _inherits(Schema, _Model_1$default);

  var _super = _createSuper(Schema);

  function Schema(props) {
    _classCallCheck(this, Schema);

    return _super.call(this, _objectSpread(_objectSpread({}, props), {}, {
      collectionName: 'schemas',
      orderDirection: (props === null || props === void 0 ? void 0 : props.orderDirection) || 'asc',
      orderField: (props === null || props === void 0 ? void 0 : props.orderField) || 'name'
    }));
  }

  _createClass(Schema, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var document, ref;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(Schema.prototype), "create", this).call(this, data);

              case 2:
                document = _context.sent;
                ref = (0, firestore_1.doc)(this.getCollectionRef(), document.id);

                if (!(!data.collectionName && data.name)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return (0, firestore_1.updateDoc)(ref, {
                  collectionName: "".concat((0, nanoid_1.nanoid)().slice(0, 5), "_").concat((0, slug_1.default)(data.name))
                });

              case 7:
                return _context.abrupt("return", (0, firestore_1.getDoc)(ref).then(function (documentSnapshot) {
                  return _objectSpread({
                    id: documentSnapshot.id
                  }, documentSnapshot.data());
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return Schema;
}(Model_1.default);

exports.default = Schema;